import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { Modal } from '@mantine/core';

import { useAddAIPromptTemplate } from '../api/addAIPromptTemplate';
import { Fields } from '../hooks/useAIPromptTemplateForm';

import { AIPromptTemplateForm } from './AIPromptTemplateForm';

type AddModalProps = {
  initialValues: Fields;
};

export const AddModal = NiceModal.create(({ initialValues }: AddModalProps) => {
  const modal = useModal();

  const { mutate, isLoading } = useAddAIPromptTemplate({
    config: {
      onSuccess: () => modal.hide(),
    },
  });

  return (
    <Modal
      centered
      overlayProps={{ opacity: 0.4, blur: 1.5 }}
      opened={modal.visible}
      onClose={() => modal.remove()}
      title="New Prompt Template"
      size="lg"
    >
      <AIPromptTemplateForm
        isLoading={isLoading}
        onSubmit={(params) => mutate(params)}
        initialValues={initialValues}
        submitLabel="Create"
      />
    </Modal>
  );
});
